var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullscreen"},[_c('br'),(_vm.signURL != null)?_c('div',{staticClass:"fullscreen"},[_c('div',{attrs:{"id":"hello-sign-container"}})]):_c('div',[_vm._v(" Hello Sign for Mobile ")])])}
var staticRenderFns = []

export { render, staticRenderFns }